import { ReactComponent as NSWDoE } from './icon_nsw_doe.svg';
import Icon, { IconProps } from './icon';

const IconNSWDoE = (props: IconProps) => {
  return <Icon {...props} Svg={NSWDoE} />;
};

export default IconNSWDoE;
